import LetterheadSelect from 'src/components/Selects/LetterheadSelect'

import { TanstackField } from '../../../utils/forms'

type Props<TKey extends string> = {
  caption?: string
  field: TanstackField<number | null | undefined, TKey>
  isClearable?: boolean
  label?: string
  placeholder?: string
}

const LetterheadSelectField = <TKey extends string>({
  caption,
  field,
  isClearable,
  label,
  placeholder,
}: Props<TKey>) => {
  return (
    <LetterheadSelect
      caption={caption}
      isClearable={isClearable}
      label={label}
      onValueChange={field.setValue}
      placeholder={placeholder}
      value={field.state.value}
    />
  )
}

export default LetterheadSelectField
